import dayjs from "dayjs";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
type $FIXME = any;

export const fillFormData = (props: $FIXME) => {
  const formData = new FormData();
  if (props.id) {
    formData.append("Id", props.id);
  }

  formData.append(`Date`, dayjs(props.dateEvent).format("YYYY-MM-DD"));
  formData.append(
    "StartDateAcceptingApplications",
    dayjs(props.startDateAcceptingApplications).format("YYYY-MM-DD")
  );
  formData.append(
    "EndDateAcceptingApplications",
    dayjs(props.endDateAcceptingApplications).format("YYYY-MM-DD")
  );
  formData.append(
    "ParticipantNumbersPrintDate",
    dayjs(props.participantNumbersPrintDate).format("YYYY-MM-DD")
  );
  formData.append("IsActive", "true");
  formData.append("InsurancePrice", String(props.insurancePrice));

  for (let i = 0; i < props.documents.length; i++) {
    const document = props.documents[i];
    if (document instanceof File) {
      formData.append(`Documents`, document);
    } else if (Array.isArray(document) && document[0] instanceof File) {
      formData.append(`Documents`, document[0]);
    } else if (typeof document === "string") {
    }
  }

  for (let i = 0; i < props.publicOffer.length; i++) {
    formData.append(
      `OfferAgreements[${i}].LanguageId`,
      props.publicOffer[i].languageId
    );

    const file = props.publicOffer[i].file;
    if (file) {
      if (file instanceof File) {
        formData.append(`OfferAgreements[${i}].File`, file);
      } else if (file instanceof FileList && file.length > 0) {
        formData.append(`OfferAgreements[${i}].File`, file[0]);
      } else if (Array.isArray(file) && file[0] instanceof File) {
        formData.append(`OfferAgreements[${i}].File`, file[0]);
      } else if (typeof file === "string") {
      }
    }

    if (typeof props.publicOffer[i].isUpdated === "boolean") {
      formData.append(
        `OfferAgreements[${i}].isUpdated`,
        props.publicOffer[i].isUpdated
      );
    }
  }

  for (let i = 0; i < props.translations.length; i++) {
    if (props.translations[i]?.id) {
      formData.append(`Translations[${i}].Id`, props.translations[i].id);
    }
    formData.append(`Translations[${i}].Name`, props.translations[i].name);
    formData.append(
      `Translations[${i}].Text`,
      draftToHtml(convertToRaw(props.translations[i].text?.getCurrentContent()))
    );
    formData.append(`Translations[${i}].Place`, props.translations[i].place);
    formData.append(
      `Translations[${i}].LanguageId`,
      props.translations[i].languageId
    );
    formData.append(
      `Translations[${i}].StartKitMessage`,
      props.translations[i].startKitMessage
    );
    formData.append(
      `Translations[${i}].LanguageId`,
      props.translations[i].languageId
    );

    const logo = props.translations[i].logo;

    if (logo) {
      if (logo instanceof File) {
        formData.append(`Translations[${i}].Logo`, logo);
      } else if (logo instanceof FileList && logo.length > 0) {
        formData.append(`Translations[${i}].Logo`, logo[0]);
      } else if (Array.isArray(logo) && logo[0] instanceof File) {
        formData.append(`Translations[${i}].Logo`, logo[0]);
      } else if (typeof logo === "string") {
      }
    }
  }

  for (let i = 0; i < props.partners.length; i++) {
    if (props.partners[i]?.id !== null && props.partners[i]?.id !== undefined) {
      formData.append(`Partners[${i}].Id`, props.partners[i].id);
    } else {
      formData.append(`Partners[${i}].Id`, "0"); // 0 для undefined ID
    }
    formData.append(
      `Partners[${i}].SerialNumber`,
      props.partners[i].serialNumber
    );
    const translations = props.partners[i].translations;
    const partnerCompanies = props.partners[i].partnerCompanies;

    for (let x = 0; x < partnerCompanies.length; x++) {
      if (
        partnerCompanies[x]?.id !== null &&
        partnerCompanies[x]?.id !== undefined
      ) {
        formData.append(
          `Partners[${i}].PartnerCompanies[${x}].Id`,
          partnerCompanies[x].id
        );
      }

      const partnerLogo = partnerCompanies[x].logo;
      if (partnerLogo) {
        if (partnerLogo instanceof File) {
          formData.append(
            `Partners[${i}].PartnerCompanies[${x}].Logo`,
            partnerLogo
          );
        } else if (partnerLogo instanceof FileList && partnerLogo.length > 0) {
          formData.append(
            `Partners[${i}].PartnerCompanies[${x}].Logo`,
            partnerLogo[0]
          );
        } else if (
          Array.isArray(partnerLogo) &&
          partnerLogo[0] instanceof File
        ) {
          formData.append(
            `Partners[${i}].PartnerCompanies[${x}].Logo`,
            partnerLogo[0]
          );
        } else if (typeof partnerLogo === "string") {
        }
      }

      formData.append(
        `Partners[${i}].PartnerCompanies[${x}].Name`,
        partnerCompanies[x].name
      );
      formData.append(
        `Partners[${i}].PartnerCompanies[${x}].Url`,
        partnerCompanies[x].url
      );
    }

    for (let x = 0; x < translations.length; x++) {
      formData.append(
        `Partners[${i}].Translations[${x}].Name`,
        translations[x].name
      );
      formData.append(
        `Partners[${i}].Translations[${x}].LanguageId`,
        translations[x].languageId
      );
      if (translations[x]?.id !== null && translations[x]?.id !== undefined) {
        formData.append(
          `Partners[${i}].Translations[${x}].Id`,
          translations[x].id
        );
      }
    }
  }

  formData.append("InsurancePrice", props.insurancePrice);

  for (let i = 0; i < props.distances.length; i++) {
    const d = props.distances[i];
    const distancePrices = d.distancePrices;
    const distanceAges = [
      ...(d.true || []).map((item: any) => ({ ...item, gender: true })),
      ...(d.false || []).map((item: any) => ({ ...item, gender: false })),
    ];

    if (d.id) {
      formData.append(`Distances[${i}].Id`, d.id);
    }

    formData.append(`Distances[${i}].Name`, String(d.name));
    formData.append(`Distances[${i}].HasInsurance`, String(d.hasInsurance));

    if (d.startNumberRanges && d.startNumberRanges.length > 0) {
      const firstRange = d.startNumberRanges[0];
      formData.append(
        `Distances[${i}].StartNumbersFrom`,
        firstRange.startNumbersFrom
      );
      formData.append(
        `Distances[${i}].StartNumbersTo`,
        firstRange.startNumbersTo
      );
    }

    d.startNumberRanges?.forEach(
      (
        range: { startNumbersFrom: any; startNumbersTo: any; id?: any },
        j: number
      ) => {
        if (props.id && range.id) {
          formData.append(
            `Distances[${i}].StartNumberRanges[${j}].Id`,
            range.id
          );
        }
        formData.append(
          `Distances[${i}].StartNumberRanges[${j}].StartNumbersFrom`,
          range.startNumbersFrom
        );
        formData.append(
          `Distances[${i}].StartNumberRanges[${j}].StartNumbersTo`,
          range.startNumbersTo
        );
      }
    );

    for (let x = 0; x < distancePrices.length; x++) {
      if (props.id && distancePrices[x].id) {
        formData.append(
          `Distances[${i}].DistancePrices[${x}].Id`,
          distancePrices[x].id
        );
      }
      formData.append(
        `Distances[${i}].DistancePrices[${x}].DateStart`,
        dayjs(distancePrices[x].dateStart).format("YYYY-MM-DD")
      );
      formData.append(
        `Distances[${i}].DistancePrices[${x}].DateEnd`,
        dayjs(distancePrices[x].dateEnd).format("YYYY-MM-DD")
      );
      formData.append(
        `Distances[${i}].DistancePrices[${x}].Price`,
        distancePrices[x].price
      );
    }

    for (let x = 0; x < distanceAges.length; x++) {
      if (props.id && distanceAges[x].id) {
        formData.append(
          `Distances[${i}].DistanceAges[${x}].Id`,
          distanceAges[x].id
        );
      }
      formData.append(
        `Distances[${i}].DistanceAges[${x}].Gender`,
        String(distanceAges[x].gender)
      );
      formData.append(
        `Distances[${i}].DistanceAges[${x}].AgeFrom`,
        String(distanceAges[x].ageFrom)
      );
      formData.append(
        `Distances[${i}].DistanceAges[${x}].AgeTo`,
        String(distanceAges[x].ageTo)
      );
    }
  }

  return formData;
};

const fetchFileFromUrl = async (
  url: string,
  filename: string
): Promise<File> => {
  try {
    if (url.length > 200) {
      return new File([""], filename);
    }

    let fullUrl = url;
    if (url.startsWith("staticfiles/")) {
      const baseUrl =
        process.env.REACT_APP_DEFAULT_IMAGE_URL || window.location.origin;
      fullUrl = `${baseUrl}${url}`;
    } else if (url.startsWith("staticfiles/")) {
      const baseUrl =
        process.env.REACT_APP_DEFAULT_IMAGE_URL || window.location.origin;
      fullUrl = `${baseUrl}${url}`;
    }

    const response = await fetch(fullUrl);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();

    if (blob.type === "text/html" && blob.size < 2000) {
      throw new Error("File not found on server");
    }

    const fileExtension = filename.split(".").pop() || "";
    const shortFilename = `file.${fileExtension}`;

    return new File([blob], shortFilename, { type: blob.type });
  } catch (error) {
    return new File([""], filename);
  }
};

export const fillUpdateData = async (props: $FIXME) => {

  const formData = new FormData();
  if (props.id) {
    formData.append("Id", props.id);
  }

  formData.append(`Date`, dayjs(props.dateEvent).format("YYYY-MM-DD"));
  formData.append(
    "StartDateAcceptingApplications",
    dayjs(props.startDateAcceptingApplications).format("YYYY-MM-DD")
  );
  formData.append(
    "EndDateAcceptingApplications",
    dayjs(props.endDateAcceptingApplications).format("YYYY-MM-DD")
  );
  formData.append(
    "ParticipantNumbersPrintDate",
    dayjs(props.participantNumbersPrintDate).format("YYYY-MM-DD")
  );
  formData.append("IsActive", "true");
  formData.append("InsurancePrice", String(props.insurancePrice));

  for (let i = 0; i < props.documents.length; i++) {
    const document = props.documents[i];

    if (document instanceof File) {
      formData.append(`Documents`, document);
    } else if (Array.isArray(document) && document[0] instanceof File) {
      formData.append(`Documents`, document[0]);
    } else if (typeof document === "string") {
      const fileExtension = document.split(".").pop() || "";
      const shortFilename = `file.${fileExtension}`;
      const realFile = await fetchFileFromUrl(document, shortFilename);
      formData.append(`Documents`, realFile);
    } else if (document && typeof document === "object" && document.file) {
      if (document.file instanceof File) {
        formData.append(`Documents`, document.file);
      } else if (typeof document.file === "string") {
        const fileExtension = document.file.split(".").pop() || "";
        const shortFilename = `file.${fileExtension}`;
        const realFile = await fetchFileFromUrl(document.file, shortFilename);
        formData.append(`Documents`, realFile);
      }
    }
  }

  for (let i = 0; i < props.publicOffer.length; i++) {
    formData.append(
      `OfferAgreements[${i}].LanguageId`,
      props.publicOffer[i].languageId
    );

    const file = props.publicOffer[i].file;
    if (file) {
      if (file instanceof File) {
        formData.append(`OfferAgreements[${i}].File`, file);
      } else if (file instanceof FileList && file.length > 0) {
        formData.append(`OfferAgreements[${i}].File`, file[0]);
      } else if (Array.isArray(file) && file[0] instanceof File) {
        formData.append(`OfferAgreements[${i}].File`, file[0]);
      } else if (typeof file === "string") {
        const fileExtension = file.split(".").pop() || "";
        const shortFilename = `file.${fileExtension}`;
        const realFile = await fetchFileFromUrl(file, shortFilename);
        formData.append(`OfferAgreements[${i}].File`, realFile);
      }
    }

    if (typeof props.publicOffer[i].isUpdated === "boolean") {
      formData.append(
        `OfferAgreements[${i}].isUpdated`,
        props.publicOffer[i].isUpdated
      );
    }
  }

  for (let i = 0; i < props.translations.length; i++) {
    if (props.translations[i] && typeof props.translations[i] === "object") {
      if (props.translations[i].id) {
        formData.append(`Translations[${i}].Id`, props.translations[i].id);
      }
      formData.append(`Translations[${i}].Name`, props.translations[i].name);
      formData.append(
        `Translations[${i}].Text`,
        draftToHtml(
          convertToRaw(props.translations[i].text?.getCurrentContent())
        )
      );
      formData.append(`Translations[${i}].Place`, props.translations[i].place);
      formData.append(
        `Translations[${i}].LanguageId`,
        props.translations[i].languageId
      );
      formData.append(
        `Translations[${i}].StartKitMessage`,
        props.translations[i].startKitMessage
      );
      formData.append(
        `Translations[${i}].LanguageId`,
        props.translations[i].languageId
      );

      const logo = props.translations[i].logo;

      if (logo) {
        if (logo instanceof File) {
          formData.append(`Translations[${i}].Logo`, logo);
        } else if (logo instanceof FileList && logo.length > 0) {
          formData.append(`Translations[${i}].Logo`, logo[0]);
        } else if (Array.isArray(logo) && logo[0] instanceof File) {
          formData.append(`Translations[${i}].Logo`, logo[0]);
        } else if (typeof logo === "string") {
          const fileExtension = logo.split(".").pop() || "";
          const shortFilename = `file.${fileExtension}`;
          const realFile = await fetchFileFromUrl(logo, shortFilename);
          formData.append(`Translations[${i}].Logo`, realFile);
        }
      }
    }
  }

  for (let i = 0; i < props.partners.length; i++) {
    if (props.partners[i]?.id !== null && props.partners[i]?.id !== undefined) {
      formData.append(`Partners[${i}].Id`, props.partners[i].id);
    } else {
      formData.append(`Partners[${i}].Id`, "0");
    }
    formData.append(
      `Partners[${i}].SerialNumber`,
      props.partners[i].serialNumber
    );
    const translations = props.partners[i].translations;
    const partnerCompanies = props.partners[i].partnerCompanies;

    for (let x = 0; x < partnerCompanies.length; x++) {
      if (partnerCompanies[x]?.id) {
        formData.append(
          `Partners[${i}].PartnerCompanies[${x}].Id`,
          partnerCompanies[x].id
        );
      }

      const partnerLogo = partnerCompanies[x].logo;
      if (partnerLogo) {
        if (partnerLogo instanceof File) {
          formData.append(
            `Partners[${i}].PartnerCompanies[${x}].Logo`,
            partnerLogo
          );
        } else if (partnerLogo instanceof FileList && partnerLogo.length > 0) {
          formData.append(
            `Partners[${i}].PartnerCompanies[${x}].Logo`,
            partnerLogo[0]
          );
        } else if (
          Array.isArray(partnerLogo) &&
          partnerLogo[0] instanceof File
        ) {
          formData.append(
            `Partners[${i}].PartnerCompanies[${x}].Logo`,
            partnerLogo[0]
          );
        } else if (typeof partnerLogo === "string") {
          const fileExtension = partnerLogo.split(".").pop() || "";
          const shortFilename = `file.${fileExtension}`;
          const realFile = await fetchFileFromUrl(partnerLogo, shortFilename);
          formData.append(
            `Partners[${i}].PartnerCompanies[${x}].Logo`,
            realFile
          );
        }
      }

      formData.append(
        `Partners[${i}].PartnerCompanies[${x}].Name`,
        partnerCompanies[x].name
      );
      formData.append(
        `Partners[${i}].PartnerCompanies[${x}].Url`,
        partnerCompanies[x].url
      );
    }

    for (let x = 0; x < translations.length; x++) {
      formData.append(
        `Partners[${i}].Translations[${x}].Name`,
        translations[x].name
      );
      formData.append(
        `Partners[${i}].Translations[${x}].LanguageId`,
        translations[x].languageId
      );
      if (translations[x]?.id) {
        formData.append(
          `Partners[${i}].Translations[${x}].Id`,
          translations[x].id
        );
      }
    }
  }

  if (props.distances && Array.isArray(props.distances)) {
    for (let i = 0; i < props.distances.length; i++) {
      if (props.distances[i]?.id) {
        formData.append(`Distances[${i}].Id`, props.distances[i].id);
      }
      formData.append(`Distances[${i}].Name`, props.distances[i].name);
      formData.append(
        `Distances[${i}].HasInsurance`,
        props.distances[i].hasInsurance
      );

      const startNumberRanges = props.distances[i].startNumberRanges;
      const distancePrices = props.distances[i].distancePrices;
      const distanceAges = props.distances[i].true;

      for (let x = 0; x < startNumberRanges.length; x++) {
        if (startNumberRanges[x]?.id) {
          formData.append(
            `Distances[${i}].StartNumberRanges[${x}].Id`,
            startNumberRanges[x].id
          );
        }
        formData.append(
          `Distances[${i}].StartNumberRanges[${x}].StartNumbersFrom`,
          String(startNumberRanges[x].startNumbersFrom)
        );
        formData.append(
          `Distances[${i}].StartNumberRanges[${x}].StartNumbersTo`,
          String(startNumberRanges[x].startNumbersTo)
        );
      }

      for (let x = 0; x < distancePrices.length; x++) {
        if (distancePrices[x]?.id) {
          formData.append(
            `Distances[${i}].DistancePrices[${x}].Id`,
            distancePrices[x].id
          );
        }
        formData.append(
          `Distances[${i}].DistancePrices[${x}].DateStart`,
          dayjs(distancePrices[x].dateStart).format("YYYY-MM-DD")
        );
        formData.append(
          `Distances[${i}].DistancePrices[${x}].DateEnd`,
          dayjs(distancePrices[x].dateEnd).format("YYYY-MM-DD")
        );
        formData.append(
          `Distances[${i}].DistancePrices[${x}].Price`,
          String(distancePrices[x].price)
        );
      }

      for (let x = 0; x < distanceAges.length; x++) {
        if (distanceAges[x]?.id) {
          formData.append(
            `Distances[${i}].DistanceAges[${x}].Id`,
            distanceAges[x].id
          );
        }
        formData.append(
          `Distances[${i}].DistanceAges[${x}].Gender`,
          String(distanceAges[x].gender)
        );
        formData.append(
          `Distances[${i}].DistanceAges[${x}].AgeFrom`,
          String(distanceAges[x].ageFrom)
        );
        formData.append(
          `Distances[${i}].DistanceAges[${x}].AgeTo`,
          String(distanceAges[x].ageTo)
        );
      }

      const distanceAgesFalse = props.distances[i].false;
      for (let x = 0; x < distanceAgesFalse.length; x++) {
        if (distanceAgesFalse[x]?.id) {
          formData.append(
            `Distances[${i}].DistanceAges[${x + distanceAges.length}].Id`,
            distanceAgesFalse[x].id
          );
        }
        formData.append(
          `Distances[${i}].DistanceAges[${x + distanceAges.length}].Gender`,
          String(distanceAgesFalse[x].gender)
        );
        formData.append(
          `Distances[${i}].DistanceAges[${x + distanceAges.length}].AgeFrom`,
          String(distanceAgesFalse[x].ageFrom)
        );
        formData.append(
          `Distances[${i}].DistanceAges[${x + distanceAges.length}].AgeTo`,
          String(distanceAgesFalse[x].ageTo)
        );
      }
    }
  }

  return formData;
};
